module.exports = __webpack_public_path__ + "img/download-icon.2fcd8e3a.webp";